import React from 'react';
import Translation from '../../../../translation/translation';
import { FilterLabelTranslationKeys } from
    '../../../../../constants/filter/filter_label_translation_keys';


const LightboxActiveBooleanFilter = ({ filterName, onUnsetFilter }) => {
    return (
        <span className="lightbox-overview-active-filters__remove-filter" onClick={() => onUnsetFilter(filterName)}>
            <Translation translationKey={FilterLabelTranslationKeys[filterName]} />
        </span>
    );
}
export default LightboxActiveBooleanFilter;